import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { InfraService } from './infra.service';

@Injectable({
  providedIn: 'root'
})
export class DatacheckService {
  private configUrl: string;
  private configUrl_dataCheck: string;
  private templateId: number;

  constructor(private infraService: InfraService, private http: HttpClient) {
    this.infraService.infraDetails$.subscribe(data => {
      this.configUrl = data.WebEndPoint1 + 'flatfile';
      this.configUrl_dataCheck = data.WebEndPoint2 + 'dataCheck';
      this.templateId = data.TemplateId;
    });

    if (!this.infraService.isInfraDetailsAvailable && localStorage.getItem('selectedInfra') != undefined) {
      this.infraService.isInfraDetailsAvailable = true;
      this.infraService.setInfraDetails(localStorage.getItem('selectedInfra'));
    }
  }

  public getDataCheckDataPL(entityId: number) {
    return this.http.get(`${this.configUrl_dataCheck}/getDataCheckDataPL/${entityId}`);
  }

  public getDataCheckDataBS(entityId: number) {
    return this.http.get(`${this.configUrl_dataCheck}/getDataCheckDataBS/${entityId}`);
  }

  public getEntities(engagementId: number) {
    const url = `${this.configUrl}` + '/getEntities' + `/${engagementId}`;
    return this.http.get(url);
  }

  public getDataCheckDataQE(engagementId: number) {
    const url = `${this.configUrl_dataCheck}` + '/getDataCheckDataQE' + `/${engagementId}`;
    return this.http.get(url);
  }

  private handleError(error: Response) {
    return throwError(()=> error);
  }

  public getdataCheckExcel(engagementId: number, regionId: number) {
    return this.http.get(`${this.configUrl_dataCheck}/${engagementId}` + `?regionId=` + `${regionId}`, {
      responseType: 'arraybuffer'
    });
  }

  UpdatePlugNetIncome(engagementId, plugNetIncomeYears, currentengagementtemplateId) {
    return this.http.post(`${this.configUrl_dataCheck}/UpdatePlugNetIncome`, { 'EngagementId': engagementId, 'RegionId': currentengagementtemplateId, 'Years': plugNetIncomeYears });
  }

  UpdateOtherIncExp(engagementId: number, isOtherIncExpIncluded: boolean) {
    return this.http.post(`${this.configUrl_dataCheck}/UpdateOtherIncExp`, { 'Id': engagementId, 'isOtherIncExpIncluded': isOtherIncExpIncluded });
  }
}
